import { computed, unref } from 'vue';
import { useStore } from 'vuex';

const INTERNAL_PRICING_PLAN_NAMES = new Set(['Shiji', 'Imported catalog']);

export function isInternalShijiPricingPlan(plan) {
  return plan?.name && INTERNAL_PRICING_PLAN_NAMES.has(plan.name);
}

export function isIntegrationPricingPlan(plan) {
  return !!(plan?.is_integration_plan || isInternalShijiPricingPlan(plan));
}

export function isReadOnlyPricingPlan(plan) {
  if (!plan) return false;
  if (isIntegrationPricingPlan(plan)) return true;
  return !!plan.experience_id;
}

export function useShijiBookingLink(eventRef) {
  const store = useStore();

  return computed(() => {
    const event = unref(eventRef);
    if (!event) return null;

    const syncError =
      event.shiji_sync_error || event.metadata?.shiji_sync_error || null;
    const syncErrorAt = event.metadata?.shiji_sync_error_at || null;

    const withSyncState = link => ({
      ...link,
      sync_error: syncError,
      sync_error_at: syncErrorAt,
    });

    if (event.shiji_booking_link?.booking_id) {
      return withSyncState(event.shiji_booking_link);
    }

    const bookingId =
      event.metadata?.shiji_booking_id ||
      event.custom_attributes?.shiji_booking_id;

    if (!bookingId && !syncError) return null;

    const connections = store.getters['dataHub/getConnections'] || [];
    const connection =
      connections.find(
        c =>
          Number(c.id) === Number(event.metadata?.shiji_connection_id) ||
          c.adapter_type === 'shiji'
      ) || null;

    const baseUrl = connection?.destination_config?.base_url
      ?.replace('.identity.', '.web.')
      ?.replace('.api.', '.web.');

    return withSyncState({
      booking_id: bookingId || null,
      booking_code:
        event.metadata?.shiji_booking_code ||
        event.custom_attributes?.shiji_booking_code ||
        null,
      booking_status:
        event.custom_attributes?.shiji_booking_status ||
        event.metadata?.shiji_booking_status ||
        null,
      connection_id:
        connection?.id || event.metadata?.shiji_connection_id || null,
      connection_name: connection?.name || 'Shiji',
      url:
        bookingId && baseUrl
          ? `${baseUrl.replace(/\/$/, '')}/meetings-and-events/booking/${bookingId}/booking-details/`
          : null,
    });
  });
}
